import "./style.scss";

export default function ButtonPrimary({ btnContent, onClick, disabled }) {
  return (
    <button className="button-primary" onClick={onClick} disabled={disabled}>
      {btnContent}
    </button>
  );
}
